/* Publish by EComposer at 2026-09-27 22:35:05*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-kujmll2elx"]=  window.__ectimmers["ecom-kujmll2elx"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-kujmll2elx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kujmll2elx', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qecyc5wxjrb"]=  window.__ectimmers["ecom-qecyc5wxjrb"] || {};
if(!this.$el||!window.EComModal)return;const t=this.isLive;let e=this.$el.querySelectorAll("[ecom-modal]");e.length&&t&&new window.EComModal(e,{gallery:!0,cssClass:["ecom-container-lightbox-"+this.id]})

                    });
                    
                        document.querySelectorAll('.ecom-qecyc5wxjrb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qecyc5wxjrb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ztmmocp3h2b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ztmmocp3h2b', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}